import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LogoMark from '../LogoMark';
import * as types from '../../Config/permissionConstant';
import {
  SideMenuContainer,
  LogoContainer,
  NavIconsContainer,
  NavIconList,
  IconListItem,
  NavItemLink,
  IconListFullWidth,
  Avatar,
  MinMaxButton,
  AvatarButton,
  AlphaLogo,
  AIRCloudWithTextIconImg,
} from './styles';
import Divider from '../Divider';
import LifeBouy from '../Icons/LifeBouy';
import Settings from '../Icons/Settings';
import Maximize from '../Icons/Maximize';
import Plus from '../Icons/Plus';
import avatar from '../../Assets/images/avatar.png';
import { Link, useHistory, useParams } from 'react-router-dom';
import { AddNewButton } from '../../Layouts/DashboardLayout/styles';
import Minimize from '../Icons/Minimize';
import SideBarStatus from '../../Enums/SideBarStatus';
import {
  hideSideBarPage,
  showSideBarPage,
  updateSideBarState,
} from '../../Redux/actions/sidebar';
import SideBarPageType from '../../Enums/SideBarPageType';
import { clearToken, setLoginCallBack } from '../../Redux/actions/login';
import {
  apiProjectGetRequest,
  apiProjectGetSuccess,
  resetProject,
  resetProjectState,
} from '../../Redux/actions/project';
import Archive from 'Components/Icons/Archive';
import Camera from 'Components/Icons/Camera';
import sampleProject from 'Assets/images/sampleProject.svg';
import { showWelcomeModal, updateTutorialState } from 'Redux/actions/tutorial';
import {
  apiGetUserInformation,
  apiPatchUserInformation,
} from 'Redux/actions/user_information';
import PlusNaked from 'Components/Icons/PlusNaked';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { getObjectByLowestValue } from '../../Utils/permissions';
import { toggleSidePan } from 'Redux/actions/shoot';
import { sortByDate } from 'Utils/helper';
import AIRcloudWithTextIcon from '../../Assets/images/AIRcloudWithTextIcon.png';

const SideMenu = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { project_id } = useParams();

  const projectState = useSelector(state => state.project);
  const sidebarState = useSelector(state => state.sidebar);
  const auth = useSelector(state => state.auth);
  const tutorialState = useSelector(state => state.tutorial);
  const userInformation = useSelector(state => state.userInformation);
  const showModal = userInformation?.data?.tutorial;
  const allowedPermission = getObjectByLowestValue(
    userInformation?.data?.organisation_data,
    'role',
  )?.allowed_permissions;

  useEffect(() => {
    if (auth.token) {
      dispatch(apiGetUserInformation(auth.user_information?.id, auth.token));
    }
  }, []);

  // Fetch unconditionally: a user with no organisation yet still needs the list to
  // resolve (to an empty one), otherwise WelcomePage waits forever on a null list.
  useEffect(() => {
    dispatch(
      apiProjectGetRequest(auth.token, userInformation?.selectedOrganisation),
    );
  }, [userInformation?.selectedOrganisation]);

  useEffect(() => {
    if (projectState.success) {
      dispatch(resetProject());
      updateSideBarState({
        ...sidebarState,
        pageType: SideBarPageType.PROJECT,
        status: SideBarStatus.OPEN,
      });
    } else if (projectState.postSuccess) {
      dispatch(resetProject());
      dispatch(
        updateSideBarState({
          ...sidebarState,
          pageType: SideBarPageType.PROJECT,
          status: SideBarStatus.OPEN,
        }),
      );
    }
  }, [projectState.success, projectState.postSuccess]);

  const toggleSidebarPage = () => {
    dispatch(toggleSidePan());
    if (sidebarState.status === SideBarStatus.OPEN) {
      dispatch(hideSideBarPage());
    } else {
      dispatch(showSideBarPage());
    }
  };

  const hideSidebarPage = () => {
    dispatch(
      updateSideBarState({
        ...sidebarState,
        pageType: SideBarPageType.PROJECT,
        status: SideBarStatus.OPEN,
      }),
    );
  };

  const addNewProjectClicked = () => {
    dispatch(
      updateSideBarState({
        ...sidebarState,
        pageType: SideBarPageType.ADD_PROJECT,
        status: SideBarStatus.OPEN,
      }),
    );
  };

  return (
    <SideMenuContainer className={'side-menu'}>
      <LogoContainer
        to={auth.user_information?.first_login ? '/' : '/air-help'}
        onClick={hideSidebarPage}
        className="help-desk"
      >
        <AIRCloudWithTextIconImg src={AIRcloudWithTextIcon} alt="" />
        {/* <LogoMark /> */}
      </LogoContainer>
      <Divider />
      <NavIconsContainer className="sticky-top">
        <NavIconList
          className="nav"
          style={{
            // height: 'calc(100vh - 495px)',
            height: 'calc(100vh - 435px)',
            justifyContent: 'flex-start',
          }}
        >
          {/* {(auth.user_information?.first_login && showModal === true) || */}
          {tutorialState?.run === true && (
            <IconListItem
              key="0"
              className="sample-project"
              isSelected={
                sidebarState.selectedProject?.id === '0' ? true : false
              }
            >
              <Link
                to="#"
                className="text-decoration-none"
                onClick={hideSidebarPage}
              >
                <img
                  style={{ display: 'block' }}
                  src={sampleProject}
                  alt={'Sample Project'}
                />
              </Link>
            </IconListItem>
          )}

          {sortByDate(projectState?.projectList, 'shoot_date', -1)?.map(
            project =>
              project.status !== 0 && (
                <OverlayTrigger
                  key={project?.id}
                  placement={'right'}
                  overlay={
                    <Tooltip id={`tooltip-${project?.id}`}>
                      {project.name}
                    </Tooltip>
                  }
                >
                  <IconListItem
                    key={project?.id}
                    isSelected={
                      (sidebarState.selectedProject?.id === project?.id &&
                        project_id) ||
                      false
                    }
                  >
                    <Link
                      to={`/project/overview/${project?.id}`}
                      className="text-decoration-none"
                      onClick={hideSidebarPage}
                    >
                      {project?.logo ? (
                        <img
                          style={{ display: 'block', objectFit: 'contain' }}
                          src={project?.logo}
                          alt={project?.id}
                        />
                      ) : (
                        <AlphaLogo>{project?.name[0].toUpperCase()}</AlphaLogo>
                      )}
                    </Link>
                  </IconListItem>
                </OverlayTrigger>
              ),
          )}
        </NavIconList>

        <NavIconList className="nav">
          {allowedPermission?.PROJECTS?.includes(types.CREATE_PROJECT) && (
            <OverlayTrigger
              key={'add-project'}
              placement={'right'}
              overlay={
                <Tooltip id={`tooltip-add-project`}>Add New Project</Tooltip>
              }
            >
              <IconListItem>
                <AddNewButton onClick={addNewProjectClicked}>
                  <PlusNaked strokeColor="#667085" />{' '}
                </AddNewButton>
              </IconListItem>
            </OverlayTrigger>
          )}

          <OverlayTrigger
            key={'robot-status'}
            placement={'right'}
            overlay={
              <Tooltip id={`tooltip-robot-status`}>
                Robot Status
              </Tooltip>
            }
          >
            <IconListItem className="robot-status">
              <NavItemLink
                to={'/robot-status-dashboard'}
                onClick={hideSidebarPage}
              >
                <Camera/>
              </NavItemLink>
            </IconListItem>
          </OverlayTrigger>

          {(auth.user_information?.first_login && showModal === true) ||
          tutorialState?.run === true ||
          allowedPermission?.ARCHIVED_PROJECTS ? (
            <OverlayTrigger
              key={'archived-projects'}
              placement={'right'}
              overlay={
                <Tooltip id={`tooltip-archived-projects`}>
                  Archived Projects
                </Tooltip>
              }
            >
              <IconListItem className="archive-projects">
                <NavItemLink
                  to={
                    allowedPermission?.ARCHIVED_PROJECTS
                      ? '/archive-projects'
                      : '#'
                  }
                  onClick={hideSidebarPage}
                  className="archive"
                >
                  <Archive />
                </NavItemLink>
              </IconListItem>
            </OverlayTrigger>
          ) : null}

          {/* <OverlayTrigger
            key={'help-rticles'}
            placement={'right'}
            overlay={
              <Tooltip id={`tooltip-help-articles`}>Help Articles</Tooltip>
            }
          >
            <IconListItem>
              <NavItemLink to="#" className="help-desk">
                <LifeBouy />
              </NavItemLink>
            </IconListItem>
          </OverlayTrigger> */}
          {/* <IconListItem>
            <NavItemLink to="/settings/account-details">
              <Settings />
            </NavItemLink>
          </IconListItem> */}
          <OverlayTrigger
            key={'minmax'}
            placement={'right'}
            overlay={
              <Tooltip id={`tooltip-minmax`}>
                {sidebarState?.status !== SideBarStatus.OPEN
                  ? 'Expand'
                  : 'Collapse'}
              </Tooltip>
            }
          >
            <IconListItem>
              <MinMaxButton onClick={toggleSidebarPage}>
                {sidebarState?.status === SideBarStatus.OPEN ? (
                  <Minimize />
                ) : (
                  <Maximize />
                )}
              </MinMaxButton>
            </IconListItem>
          </OverlayTrigger>
          <IconListFullWidth>
            <Divider />
          </IconListFullWidth>
          <li>
            <OverlayTrigger
              key={'my-settings'}
              placement={'right'}
              overlay={
                <Tooltip id={`tooltip-my-settings`}>My Settings</Tooltip>
              }
            >
              <NavItemLink
                  to="/settings/account-details"
                  onClick={hideSidebarPage}
              >
                <Avatar
                  src={
                    userInformation?.data?.profile_image ||
                    auth?.user_information?.profile_image ||
                    avatar
                  }
                  alt=""
                />
              </NavItemLink>
            </OverlayTrigger>
          </li>
        </NavIconList>
      </NavIconsContainer>
    </SideMenuContainer>
  );
};

export default SideMenu;
